/**
 * Sorts an array **in place** based on the order of another array.
 * Items that don't exist in the other array will be placed at the end in their original order.
 * @param array - The array to sort.
 * @param otherArray - The array to use for sorting.
 * @param isSameItem - A function that determines if two items are the same.
 * @returns the sorted array
 */
export const sortArrayByOtherArray = <T>(array: T[], otherArray: T[], isSameItem: (item: T, item2: T) => boolean) => {
    return array.sort((a, b) => {
        let aIndex = otherArray.findIndex((item) => isSameItem(item, a));
        let bIndex = otherArray.findIndex((item) => isSameItem(item, b));

        if (aIndex === -1) {
            aIndex = Infinity;
        }

        if (bIndex === -1) {
            bIndex = Infinity;
        }

        return aIndex - bIndex;
    });
};
